import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { TutorBillingExportType } from '@brighterly/lib-core-types/tutor/enums'

import { TUTOR_BILLING_EXPORT_TYPE_OPTIONS } from '../config/tutor-billing'

export const resolveTutorBillingExportTypeOptions = (options: AppSelectOption[]): AppSelectOption<TutorBillingExportType>[] =>
  options.length ? options as AppSelectOption<TutorBillingExportType>[] : TUTOR_BILLING_EXPORT_TYPE_OPTIONS
